module.exports = __webpack_public_path__ + "img/ss_ico.4130122e.png";